// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingIndicator-container-2debN"};